import url from './url';



export default url(({ visualizationId = ':visualizationId' }) => `/templates/visualizations/${visualizationId}/view`);
